module.exports = __webpack_public_path__ + "static/media/unihr_logo.3f99d282.png";